import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { AveragePlayerScore } from '@sorare/core/src/__generated__/globalTypes';
import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { cardAttributes } from '@sorare/core/src/lib/glossary';

const Sticky = styled.div`
  position: sticky;
  top: calc(var(--current-stack-height) + var(--unit) * 6);
  background-color: var(--c-black);
  padding: 0 0 var(--unit);
  z-index: 1;
`;
type Props = {
  averagePlayerScore: AveragePlayerScore;
  onChange: (value: AveragePlayerScore) => void;
};
export const AveragePlayerScoreSwitch = ({
  averagePlayerScore,
  onChange,
}: Props) => {
  return (
    <Sticky>
      <TextSwitch
        value={averagePlayerScore}
        onChange={onChange}
        options={[
          {
            label: <FormattedMessage {...cardAttributes.last5} />,
            value: AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE,
          },
          {
            label: <FormattedMessage {...cardAttributes.last10} />,
            value: AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE,
          },
          {
            label: <FormattedMessage {...cardAttributes.last40} />,
            value: AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE,
          },
        ]}
      />
    </Sticky>
  );
};
